// TODO: Sort out dependency - constants should be constant and not imported from services
import FlagNigeria from "@zenith/assets/icons/FlagNigeria";
import { OPEN_PAYMENT_LINK, PAYMENT_LINK } from "@zenith/routes/paths";
import {
  OperationReqBaseDTO,
  // OperationReqRefundDTO,
} from "@zenith/services/transactions";
import {
  CreateUserOnboardingRequestDTO,
  SendOtpDTO,
} from "@zenith/services/user";

// META
export const ENV = import.meta.env;

// ENVIRONMENT
export const IS_PRODUCTION =
  ENV.VITE_USER_DEPLOYMENT_INSTANCE_TYPE === "PRODUCTION";

// Outlet Management is released on every instance, production included. The
// flag stays as the single switch that registers its routes and shows its
// entry points, so it can still be held back by flipping this one value.
export const IS_OUTLET_MANAGEMENT_ENABLED = true;

// Multi-signatory business onboarding is released on every instance,
// production included: production now routes a multi-signatory registration
// through the checklist instead of the individual sign-up flow. Kept as one
// switch because it also gates the resume path in
// useBusinessRegistrationStatus and the registration-type step.
export const IS_MULTI_SIGNATORY_ENABLED = true;

// Refund is hidden for now on every instance, not just production.
export const IS_REFUND_ENABLED = false;

// COOKIES
export const ACCESS = "ZENITH_ACCESS";
export const REFRESH = "ZENITH_REFRESH";

// KEYS
export const GOOGLE_MAPS_API_KEY = ENV.VITE_GOOGLE_MAPS_API_KEY;

// URLS
export const BASE_URL = ENV.VITE_BASE_URL;
export const PAYMENT_LINK_BASE_URL = BASE_URL + PAYMENT_LINK;
export const OPEN_PAYMENT_LINK_BASE_URL = BASE_URL + OPEN_PAYMENT_LINK;
export const TERMS_AND_CONDITIONS = ENV.VITE_TERMS_AND_CONDITIONS_LINK;
export const TWO_FACTOR_AUTHENTICATION_TUTORIAL_LINK =
  "https://www.zenithbank.com/images/DATA-PRIVACY-POLICY.html";

// Dates and Times
export const MIN_DATE = "1900-01-01-T00:00:00.000Z";
export const OTP_REFRESH_SECONDS = 60;
export const SELFIE_VERIFICATION_COUNTDOWN_SECONDS = 5 * 60;
export const SELFIE_VERIFICATION_SLOW_THRESHOLD_SECONDS = 30;
export const TRANSACTION_DATE_FORMAT = "D MMM YYYY";
export const TRANSACTION_TIME_FORMAT = "hh:mm:ss a";
export const TRANSACTIONS_DATE_FORMAT = "DD MMM YY";
export const TRANSACTIONS_DATE_FILTER_FORMAT = "YYYY-MM-DD";

// Numerical Constants
export const PERCENTAGE = 100;
export const MILLISECONDS = 1000;
export const SECONDS = 60;
export const MINUTES = 3600;
export const NG_PHONE_LENGTH = 11;
export const GH_PHONE_LENGTH = 10;
export const LOAN_INCREMENTAL_VALUE = 1000;
export const DEFAULT_TOKEN_EXPIRY = 3600;
export const DEFAULT_REFRESH_TOKEN_EXPIRY = 2592000;

// Numbers
export const PIN_LENGTH = 6;
export const MAX_DIRECTORS_LENGTH = 10;
export const PHONE_NUMBER_LENGTH = 11;
export const TRADING_NAME_LENGTH = 30;
export const TRANSACTIONS_PIN_LENGTH = 4;
export const TRANSACTION_AMOUNT_LIMIT = 30_000;
export const WALLET_BALANCE_LIMIT = 300_000;
export const SSE_WAITING_MINUTES = 1 / 6;
export const ACCOUNT_NUMBER_LENGTH = 10;
export const DEFAULT_PAGE_SIZE = 10;
export const SECTOR_SUB_CATEGORIES_LIMIT = 50;
export const MAX_BENEFICIARY_ACCOUNT_NUMBER_LENGTH = 10;
export const OPERATION_ID_SHOWING_NUMBER_LENGTH = -12;
export const TRANSACTIONS_PAGE_SIZE = 16;
export const POS_DEVICES_PAGE_SIZE = 10;
export const TRANSACTIONS_LIMIT_NUMBER = 5000;
export const EXPIRATION_DATE_FOR_PAYMENTS = 10 * MILLISECONDS;
export const INACTIVITY_TIMER = Number(ENV.VITE_INACTIVITY_TIMER);
export const LOGOUT_TIMER = Number(ENV.VITE_LOGOUT_TIMER);
export const TEAM_MEMBERS_PAGE_SIZE = 10;
export const MAX_SSE_LISTENER_HEARTBEAT_TIMEOUT = 1_800_000;
export const MAX_SIZE = 10_000_000; // 10MB
export const MIN_SIZE_SMILE_ID = 600_000; // 600KB
export const MIN_SIZE_BACK_OFFICE = 0;
export const BANK_VERIFICATION_NUMBER_LENGTH = 11;
export const INTERNATIONAL_PASSPORT_NUMBER_LENGTH = 9;
export const DRIVER_LICENCE_NUMBER_LENGHT = 12;
export const VOTERS_CARD_NUMBER_LENGHT = 19;
export const RESIDENT_PERMIT_NUMBER_LENGHT = 8;
export const NATIONAL_IDENTIFICATION_NUMBER_LENGTH = 11;
export const DEFAULT_POSITION: google.maps.LatLngLiteral = {
  lat: 8.246271012897209,
  lng: 7.696935565193654,
};
export const PAYMENT_MIN_AMOUNT = 100;
export const PAYMENT_MAX_AMOUNT = 9999999999.99;
export const TRANSACTIONS_DESCRIPTION_LENGTH = 70;

//icons
export const FLAG_ICON = FlagNigeria;

// Strings
export const PHONE_NUMBER_PREFIX = "+234";
export const DOCUMENTS_JOB_ID = "documentsJobId";
export const SELFIE_JOB_ID = "selfieJobId";
export const SELFIE_JOB_ID_SIGNUP = "selfieJobId";
export const UNLIMITED = "Unlimited";

//PURPOSES
export const DEFAULT_PURPOSE = SendOtpDTO.purpose.SIGN_IN;
export const TRX_PURPOSE = SendOtpDTO.purpose.TRANSACTION_PIN;
export const NON_CUSTOMER_SIGN_UP =
  CreateUserOnboardingRequestDTO.purpose.NON_CUSTOMER_SIGN_UP;
export const CUSTOMER_SIGN_UP =
  CreateUserOnboardingRequestDTO.purpose.CUSTOMER_SIGN_UP;
export const TRANSACTION_PIN_PURPOSE = SendOtpDTO.purpose.TRANSACTION_PIN;
// BOAS-8972: multi-signatory Change Passcode OTP step-up, mirroring
// TRANSACTION_PIN_PURPOSE's role for the equivalent PIN-change flow.
export const PASSCODE_CHANGE_OTP_PURPOSE =
  SendOtpDTO.purpose.CHANGE_PROFILE_PASSWORD;
export const CHANGE_PROFILE_PURPOSE = SendOtpDTO.purpose.CHANGE_PROFILE;
export const TWO_FACTOR_PURPOSE = SendOtpDTO.purpose.TWO_FACTOR;
export const MISMATCH_PURPOSE = SendOtpDTO.purpose.MISMATCH_SIGN_UP;
export const SECURE_TRANSACTION_PURPOSE = SendOtpDTO.purpose.SECURE_TRANSACTION;

// Local Storage Items
export const EXPIRATION_DATE_FOR_USSD_CODE_ITEM = "expirationDateUSSD";
export const EXPIRATION_DATE_FOR_PENDING_USSD_CODE_ITEM =
  "expirationDatePendingUSSD";
export const EXPIRATION_DATE_FOR_QR_CODE_ITEM = "expirationDateQR";
export const EXPIRATION_DATE_FOR_PENDING_QR_CODE_ITEM =
  "expirationDatePendingQR";
export const EXPIRATION_DATE_FOR_BANK_TRANSFER_ITEM =
  "expirationDateBankTransfer";
export const EXPIRATION_DATE_FOR_PENDING_BANK_TRANSFER_ITEM =
  "expirationDatePendingBankTransfer";
export const EXPIRATION_DATE_FOR_CARD_ITEM = "expirationDateCard";
export const EXPIRATION_DATE_FOR_PENDING_CARD_ITEM =
  "expirationDatePendingCard";
export const TIER_TO_UPGRADE_ITEM = "tierToUpgrade";
export const UPGRADE_REG_DETAILS_KEY = "upgradeRegDetails";

//PLATFORMS
export const DEFAULT_PLATFORM = SendOtpDTO.platform.SMS;
export const WHATSAPP_PLATFORM = SendOtpDTO.platform.WHATSAPP;
export const EMAIL_PLATFORM = SendOtpDTO.platform.EMAIL;
export const VOICE_MESSAGE_PLATFORM = SendOtpDTO.platform.VOICE_MESSAGE;
export const DEFAULT_CHANNEL = "WEB";
export const DEFAULT_CURRENCY = OperationReqBaseDTO.currency.NGN;
// export const DEFAULT_REFUND_TYPE = OperationReqRefundDTO.refundType.FULL;
export const DEFAULT_REFUND_TYPE = "FULL";
export const DEFAULT_CURRENCY_SYMBOL = "₦";
export const DEFAULT_CURRENCY_LOCALE = "en-NG";
export const DEFAULT_COUNTRY_CODE = "NG";
export const GH = "GH";
export const NG = "NG";
export const ZENITH_NIGERIA_BANK_CODE = "120100";
export const FINOPAY_NIGERIA_BANK_CODE = "220100";
export const ZENITH_GHANA_BANK_CODE = "120100";
export const FINOPAY_GHANA_BANK_CODE = "220100";

// Labels
export const ACCOUNT_NUMBER_LABEL = "Account Number";
export const OUTLET_NAME_LABEL = "Outlet";
export const ZENITH_BANK_TEXT = "Zenith Bank";
export const PAYMENT_SUMMARY_LABEL = "Payment Summary";
export const CURRENT_BALANCE_LABEL = "Current Balance";
export const PENDING_BALANCE_LABEL = "Pending Balance";
export const LEDGER_BALANCE_LABEL = "Ledger Balance";
export const RECEIVE_PAYMENT_TITLE = "Receive Payment";
export const RECEIVE_PAYMENT_SUBTITLE = "Select preferred option";
export const UNIT_PRICE_LABEL = "Unit Price";
export const ENTER_AMOUNT_LABEL = "Enter Amount";
export const PRODUCT_PLACEHOLDER_LABEL = "Product";
export const PRODUCT_DESCRIPTION_PLACEHOLDER_LABEL =
  "Enter Payment Description";
export const WAITING_FOR_CONFIRMATION_LABEL =
  "Please wait, the transaction is being confirmed.";
export const AVAILABLE_BALANCE_LABEL = "Available Balance";
export const AVAILABLE_LIMIT_LABEL = "Available Limit";
export const POST_NO_DEBIT = "Limit Reached";
export const SEND_MONEY_LIMIT_LABEL = "Limit Exceeded";

// Messages
export const SOMETHING_WENT_WRONG_TITLE = "Something Went Wrong";
export const BVN_LINKED_WITH_ANOTHER_USER_BODY =
  "User already onboarded with BVN: Cannot onboard again";
export const BVN_LINKED_DOB_ISSUE =
  "BVN verification failed: Check the BVN and DOB and try again.";
export const CLIENT_INTEGRATION_ERROR_BODY = "Client Integration server error";
export const USER_ACCOUNT_NOT_FOUND_BODY = "User Not found";
export const USER_ACCOUNT_NOT_LINKED_WITH_BVN_BODY =
  "Account is not linked with BVN. Continue onboarding without a zenith account";
export const UNABLE_TO_GET_CUSTOMER_DETAILS_BODY =
  "Unable to get customer details from given Zenith account number.";
export const INCORRECT_ACCOUNT_NUMBER_BODY =
  "Incorrect Zenith account number. Please enter a valid Zenith account number.";
export const CONNECTION_MODAL_TITLE = "Internet Connection";
export const CONNECTION_MODAL_BODY =
  "There was an error connecting to the network provider, please check your internet connection.";
export const UNSTABLE_CONNECTION_MODAL_TITLE = "Unstable Connection";
export const UNSTABLE_CONNECTION_MODAL_BODY =
  "Your internet connection looks slow or unstable right now. Requests may take longer than usual.";

export const UNSTABLE_CONNECTION_AUTO_CLEAR_MS = 5_000;
export const UNSTABLE_CONNECTION_SNOOZE_MS = 120_000;
export const SERVICE_MODAL_TITLE = "Service Failure";
export const SERVICE_MODAL_BODY =
  "The service is currently unavailable. Our team is actively working to resolve the issue.";
export const INACTIVE_ACCOUNT_MODAL_TITLE = "Your Account is Inactive";
export const INACTIVE_ACCOUNT_MODAL_BODY =
  "Your Zenith account is not active at the moment. You can proceed with the onboarding process without it.";
export const MULTIPLE_SIGNATURE_ACCOUNT_BODY =
  "You are a retail multiple signatory account holder. Continue your onboarding without a Zenith account.";
export const ZENITH_ACCOUNT_MODAL_BUTTON = "Continue Without Zenith Account";
export const NOT_APPLICABLE_TEXT = "N/A";
export const LIMIT_EXCEEDED_ERROR_MODAL_TITLE = "Limit Reached";
export const LIMIT_EXCEEDED_ERROR_MODAL_BODY =
  "Sorry you can't perform this transaction. You have exhausted your limit to send money. Kindly upgrade to continue.";
export const LIMIT_EXCEEDED_ERROR_MODAL_SECOND_LINE = "";
export const UNAUTHORIZED_AMOUNT_ERROR_MODAL_TITLE =
  "Amount Exceeds Balance/Limit";
export const LIMIT_UNAUTHORIZED_AMOUNT_MODAL_BODY =
  "The amount you want to refund currently exceeds your available balance or transaction limit.";
export const TIMEOUT_ERROR_MODAL_TITLE = "Something Went Wrong";
export const TRANSFER_TIMEOUT_ERROR_MODAL_BODY =
  "Transfer failed. Please try again";
export const REFUND_TIMEOUT_ERROR_MODAL_BODY =
  "Refund submission failed. Please try again";
export const EXPORT_ERROR_MODAL_TITLE = "Export Transactions";
export const EXPORT_ERROR_MODAL_BODY = `The export will only include ${TRANSACTIONS_LIMIT_NUMBER} transactions. To export a different set of transactions, please use the available filters.`;
export const UPGRADE_ERROR_MESSAGE =
  "Not allowed to request POS. Only available for tier 3 or 4";
export const FILE_INVALID_TYPE_SMILE_ID = "File type must be JPEG";
export const FILE_INVALID_TYPE_BACK_OFFICE =
  "File type must be JPEG, PNG or PDF";
export const FILE_SIZE_MAX_LIMIT = "File exceeds size limit";
export const FILE_SIZE_MIN_LIMIT = "File size is below the minimum limit";
export const FILE_SIZE_MIN_LIMIT_NATIONAL_ID = "File must be at least 50KB";
export const FULL_NAME_IS_REQUIRED = "Full name is required";
export const EMAIL_IS_REQUIRED = "Email is required";
export const EMAIL_IS_INVALID = "Email address not valid";
export const PHONE_NUMBER_IS_REQUIRED = "Phone Number is required";
export const PHONE_NUMBER_IS_INVALID = "Phone number not valid";
export const PHONE_NUMBER_NOT_FOUND =
  "This phone number isn't linked to any account. Please try again or Sign up.";
export const DISCARD_TRANSFER_BUTTON = "Discard Transfer";
export const RETURN_TO_TRANSFER_BUTTON = "Return to Transfer";
export const DISCARD_REFUND_BUTTON = "Discard Refund";
export const DISCARD_POS_BUTTON = "Discard POS Request";
export const DISCARD_CHANGE_BUTTON = "Discard Change";
export const UPGRADE_ACCOUNT_BUTTON = "Upgrade Account";
export const TRY_AGAIN_BUTTON = "Try Again";
export const CONTINUE_BUTTON = "Continue";
export const TRANSACTION_PIN_PAGE_TITLE = "Transaction PIN";
export const TRANSACTION_PIN_PAGE_SUBTITLE = "Enter your debit transaction PIN";
export const TRANSACTION_PIN_PAGE_LABEL = "Enter Transaction PIN";
export const PIN_CODE_REQUIRED_MESSAGE = "Passcode is required";
export const BLOCKED_USER_MESSAGE =
  "This user has been blocked. Kindly reach out to our support team for help.";
export const PIN_CODE_CONFIRMATION_REQUIRED_MESSAGE =
  "Passcode code confirmation is required";
export const CURRENT_PIN_CODE_REQUIRED_MESSAGE =
  "Current Passcode code is required";
export const NEW_PIN_CODE_REQUIRED_MESSAGE = "New Passcode is required";
export const PIN_CODE_REQUIRED_FOUR_DIGITS_MESSAGE =
  "Passcode code must have four (4) digits";
export const PIN_CODE_REQUIRED_SIX_DIGITS_MESSAGE =
  "Passcode must have six (6) digits";
export const TRANSACTION_PIN_LOCKED_ERROR_MESSAGE =
  "Your Transaction PIN is locked";
export const TRANSACTION_PIN_MAXIMUM_ATTEMPTS_ERROR_MESSAGE =
  "You have reached the maximum number of attempts. Please contact support to unlock your PIN.";
export const WRONG_PIN_FIRST_TRY = "Invalid PIN. Please try again";
export const WRONG_PIN_SECOND_TRY =
  "Invalid PIN. Please note that your PIN will be locked after the third wrong attempt.";
export const SWITCH_UNAVAILABLE_MESSAGE =
  "Switch is currently unavailable. Please try again later";
export const GENERIC_ERROR_MESSAGE =
  "Your transaction could not be processed at this time. Please try again later";
export const AUTHENTICATION_CODE_REQUIRED_MESSAGE =
  "Authentication code is required";
export const AUTHENTICATION_CODE_REQUIRED_DIGITS_MESSAGE =
  "Authentication code must have six (6) digits";
export const AUTHENTICATION_CODE_IS_WRONG_MESSAGE =
  "Invalid Code. Please try again";
export const TWO_FACTOR_AUTH_PAGE_TITLE = "Authentication Code";
export const TWO_FACTOR_AUTH_PAGE_SUBTITLE =
  "Enter the 6 digits code generated in your 2FA App";
export const TWO_FACTOR_AUTH_PAGE_LABEL = "Enter Authentication Code";
export const CHANGE_TRANSACTION_PIN_MESSAGE =
  "Change your transaction PIN. This will be used to authorise your debit transactions.";
export const SETUP_TRANSACTION_PIN_MESSAGE =
  "Setup your transaction PIN. This will be used to authorise your debit transactions.";
export const CREATE_FOUR_PIN_MESSAGE = "Create four (4) digit PIN";
export const CREATE_NEW_FOUR_PIN_MESSAGE = "Create New Four (4) Digit PIN";
export const CONFIRM_FOUR_PIN_MESSAGE = "Confirm four (4) digit PIN";
export const CONFIRM_NEW_FOUR_PIN_MESSAGE = "Confirm New Four (4) Digit PIN";
export const CHANGE_PIN_MESSAGE = "Change PIN";
export const CREATE_PIN_MESSAGE = "Create PIN";
export const INVALID_DATE = "The date format is invalid";
export const START_DATE_REQUIRED = "Start date is required";
export const END_DATE_REQUIRED = "End date is required";
export const CHANGES_SAVED_SUCCESSFULLY_TOAST_TITLE = "Changes Saved";
export const CHANGES_SAVED_SUCCESSFULLY_TOAST_MESSAGE =
  "The changes you've made were saved.";
export const CHANGES_SAVED_UNSUCCESSFULLY_TOAST_TITLE =
  "Unable to Save Changes";
export const CHANGES_SAVED_UNSUCCESSFULLY_TOAST_MESSAGE =
  "Sorry, we couldn't save your changes. Please try again.";
export const DASHBOARD_TOOLTIP_MESSAGE =
  "Total amount of money in your bank account, including available balance as well as any funds that are being held or have not yet cleared.";
export const DASHBOARD_PENDING_TOOLTIP_MESSAGE =
  "Pending Balance shows the total value of payment collections you have initiated but customers have not yet completed. Once payment is successful, the amount moves to your Available Balance. You can track these payment requests under the Operations tab.";
export const POST_NO_DEBIT_MESSAGE =
  "Sorry you can't perform this transaction. You have exhausted your limit to collect money. Kindly upgrade to continue";
export const EXCEEDING_LIMITS_MODAL_TITLE = "Limit Error Warning";
export const EXCEEDING_LIMITS_MODAL_BODY =
  "The amount you are about to collect exceeds your Balance and/or Credit Limits. Please upgrade your account to increase the limit.";
export const BVN_NUMBER_MESSAGE = "Dial *565*0# to obtain your BVN";
export const PIN_MISMATCH_MESSAGE =
  "Passcode does not match. Please ensure to enter the same Passcode in both fields";
export const ORDER_SUMMARY_MODAL_TITLE = "Order Summary";

// Regex
export const BANK_VERIFICATION_NUMBER_REGEX = new RegExp(/^\d{11}$/);
export const INTERNATIONAL_PASSPORT_REGEX = new RegExp(/^[A-Za-z]{1}\d{8}$/);
export const RESIDENT_PERMIT_NUMBER_REGEX = new RegExp(/^[A-Za-z]{2}\d{6}$/);
export const DRIVER_LICENCE_REGEX = new RegExp(/^[A-Za-z0-9]{12}$/);
export const VOTER_IDENTITY_NUMBER_REGEX = new RegExp(/^[A-Za-z0-9]{19}$/);
export const REGISTRATION_NUMBER_REGEX = new RegExp(/^(BN|RC)\d{4,}$/);
export const TAX_IDENTIFICATION_REGEX = new RegExp(/^\d{8}-\d{4}$/);
export const EMAIL_REGEX = new RegExp(
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);
export const TRIPLE_DIGITS_AMOUNT_REGEX = new RegExp(
  /^0+(?=\d)|(?<=\d)(?=(?:\d{3})+(?!\d))/,
  "g"
);
export const DECIMAL_DIGITS_AMOUNT_REGEX = new RegExp(/^(\.\d{1,2})$/);
export const NUMBER_INPUT_REGEX = new RegExp(/[^0-9]/gi);
export const AMOUNT_INPUT_FIRST_REGEX = new RegExp(/^0+(?=\d)/);
export const AMOUNT_INPUT_SECOND_REGEX = new RegExp(/^0+(\d)(?=\.\d*)/);
export const ONLY_CHARACTERS_NUMBERS_AND_SPACES_REGEX = new RegExp(
  /[^a-zA-Z0-9 ]/gi
);
export const NOT_EMAIL_CHARACTERS = /[^\w\d@.-]/g;
export const SEQUENTIAL_REGEX =
  /(1234|2345|3456|4567|5678|6789|7890|0987|9876|8765|7654|6543|5432|4321|3210|0123)/;
export const SEQUENTIAL_REGEX_SIGN_UP =
  /(123456|234567|345678|456789|567890|098765|987654|876543|765432|654321|543210|012345)/;
export const REPEATED_REGEX = /(.)\1{3}/;
export const REPEATED_REGEX_SIGN_UP = /(.)\1{5}/;
export const NOT_NUMBERS_AND_DOT = new RegExp(/[^0-9.]/g);
export const ONLY_CHARACTERS_AND_SPACES_REGEX = new RegExp(/[^a-zA-Z ]/gi);
export const MIN_2_MAX_100_CHARACTERS_REGEX = new RegExp(/^.{2,100}$/);
export const ONLY_CHARACTERS_NUMBERS_OR_SPACES_REGEX = new RegExp(
  /^[a-zA-Z0-9 ]*$/
);
export const NOT_NUMBERS_AND_ONE_DOT = new RegExp(/[^0-9.]|(?<=\..*)\./g);
export const BASE64_IMG_URL_PREFIX = new RegExp(/^data:image\/[a-z]+;base64,/);
export const MIN_2_CHARACTERS_REGEX = new RegExp(/^.{2,}$/);
export const MAX_100_CHARACTERS_REGEX = new RegExp(/^.{0,100}$/);

// Discard Payment
export const DISCARD_PAYMENT_TITLE = "Discard Payment";
export const DISCARD_PAYMENT_BODY =
  "Are you sure you want to leave? All information provided will be lost.";
export const DISCARD_PAYMENT_PRIMARY_BTN_TEXT = "Discard Payment";
export const DISCARD_PAYMENT_SECONDARY_BTN_TEXT = "Return to Payment";

// Discard Transfer
export const DISCARD_TRANSFER_TITLE = "Discard Transfer";
export const DISCARD_TRANSFER_BODY =
  "Are you sure you want to leave? All information provided will be lost.";

export const SUCCESS_API_CODE = "ZENZ-CROSS-001";

// Error codes
export const WRONG_PASSCODE_ERROR_CODE = "ZENZ-USER-003";
export const LOCKED_PASSCODE_ERROR_CODE = "ZENZ-USER-004";
export const BENEFICIARY_EMAIL_OR_NUMBER_ALREADY_REGISTERED = "ZENZ-USER-006";
export const NO_BENEFICIARY_WAS_FOUND_ERROR_CODE = "ZENZ-USER-010";
export const DUPLICATE_BENEFICIARY_ERROR_CODE = "ZENZ-USER-012";
export const USERS_NOT_FOUND = "ZENZ-USER-016";
export const WRONG_AUTHENTICATION_CODE_ERROR_CODE = "ZENZ-USER-021";
export const TWO_FACTOR_AUTH_ERROR_CODE = "ZENZ-CROSS-002";
export const CLIENT_ERROR_BAD_REQUEST = "ZENZ-CROSS-004";
export const UPGRADE_ACCOUNT_ERROR_CODE = "ZENZ-CROSS-006";
// BOAS-7641/8818: the same code is commons-lib's generic AccessDeniedException
// mapping - any @PreAuthorize check across any service that finds the
// caller's role lacks the permission answers 403 with this code and message.
// The two POS screens above read it as "needs an upgrade" because POS access
// happens to be tier-gated; everywhere else it means exactly what it says.
export const PERMISSION_DENIED_ERROR_CODE = "ZENZ-CROSS-006";
export const PERMISSION_DENIED_MESSAGE =
  "You do not have permission to perform this action.";
export const TIMEOUT_ERROR_CODE = "ZENZ-CROSS-014";
export const GENERIC_ERROR_CODE = "ZENZ-TRANSACTION-012";
export const UNAUTHORIZED_BALANCE_LIMIT_ERROR_CODE = "ZENZ-TRANSACTION-013";
export const SWITCH_UNAVAILABLE_ERROR_CODE = "ZENZ-TRANSACTION-014";
export const TRANSACTION_NOT_FOUND_ERROR_CODE = "ZENZ-TRANSACTION-017";
export const PAYMENT_LINK_PAID_ERROR_CODE = "ZENZ-TRANSACTION-022";
export const OTP_REQUEST_OPTION_UNAVAILABLE = "ZENZ-USER-005";
export const TIER_UPGRADE_ERROR = "ZENZ-USER-017";
export const STOCK_PRECHECK_ERROR_CODE = "ZENZ-CROSS-400";

export const DEFAULT_POS_IMAGE = "https://i.imgur.com/4MT7YFO.png";

// File name for download
export const TRANSACTION_DETAILS_DOWNLOAD_FILENAME = "transaction_details-";
export const PAYMENTS_RECEIPT_DOWNLOAD_FILENAME = "receipt-";
export const TRANSACTIONS_EXPORT_FILENAME = "transactions";
export const OPERATIONS_EXPORT_FILENAME = "operations";
export const STATEMENTS_EXPORT_FILENAME = "Statements";

// Change Password
export const CURRENT_PASSWORD_WRONG_ERROR =
  "Passcode is wrong. Please try again";
export const PASSWORD_LENGTH_ERROR = `Passcode must have six (${PIN_LENGTH}) digits`;
export const CURRENT_PASSWORD_REQUIRED = "Current Passcode is required";
export const NEW_PASSWORD_REQUIRED = "New Passcode is required";
export const CONFIRM_PASSWORD_REQUIRED = "Passcode confirmation is required";
export const PASSWORDS_DONT_MATCH =
  "The Passcodes do not match. Please make sure to enter the same passcode in both fields";
export const PASSWORD_CHANGED_SUCCESSFULLY_TITLE = "Passcode Changed";
export const PASSWORD_CHANGED_SUCCESSFULLY_MESSAGE =
  "Your passcode has been updated successfully.";
export const PASSWORD_CHANGED_FAILED_TITLE = "Unable to Change Passcode";
export const PASSWORD_CHANGED_FAILED_MESSAGE =
  "Sorry, we couldn't change your Passcode. Please try again.";

// Create PIN
export const PIN_CREATED_FAILED_TITLE = "Unable to Create PIN";
export const PIN_CREATED_FAILED_MESSAGE =
  "Sorry, we couldn't create your transaction PIN. Please try again.";
export const PIN_CREATED_SUCCESSFULLY_TITLE = "PIN Created";
export const PIN_CREATED_SUCCESSFULLY_MESSAGE =
  "Your transaction PIN has been created.";

// Change PIN
export const PIN_CHANGED_SUCCESSFULLY_TITLE = "PIN Changed";
export const PIN_CHANGED_SUCCESSFULLY_MESSAGE =
  "Your PIN has been updated successfully.";
export const PIN_CHANGED_FAILED_TITLE = "Unable to Change PIN";
export const PIN_CHANGED_FAILED_MESSAGE =
  "Sorry, we couldn't change your transaction PIN. Please try again.";

// 2FA Code
export const CODE_REQUIRED = "Code is required";
export const CODE_LENGTH_ERROR = "Code must have six (6) digits";
export const CODE_IS_WRONG_MESSAGE = "Code is wrong. Please try again";

// Inventory Information
export const DELETE_PRODUCT_CONFIRMATION_MESSAGE =
  "Are you sure you want to delete this product?";
export const DELETE_PRODUCT_WARNING_MESSAGE =
  "Kindly note that this action is irreversible.";
export const DELETE_PRODUCT_TITLE = "Delete Product";
export const DELETE_PRODUCT_SECONDARY_BTN_TEXT = "Delete";
export const DELETE_PRODUCT_PRIMARY_BTN_TEXT = "Cancel";
export const FILE_SIZE_LIMIT_8MB = 8 * 1024 * 1024;
export const FILE_SIZE_LIMIT_5MB = 5 * 1024 * 1024;
export const MIN_PRICE_AMOUNT = 0.01;
export const MAX_PRICE_AMOUNT = 9999999999.99;
export const MAX_STOCK_AMOUNT = 9999999999;
export const MIN_STOCK_AMOUNT = 1;
export const UNIT_MEASUREMENT_ADDED_SUCCESSFULLY_TITLE =
  "Unit of Measurement Added";
export const UNIT_MEASUREMENT_ADDED_SUCCESSFULLY_MESSAGE =
  "A new unit of measurement has been added";
export const BULK_UPLOAD_TEMPLATE_NAME = "bulk-upload-template";
export const FAILED_BULK_UPLOAD_NAME = "failed-products";
export const BULK_UPLOAD_FAILURE_TITLE = "Bulk Upload Failed";
export const BULK_UPLOAD_FAILURE_MESSAGE =
  "Bulk Upload Failed. Please try again later. If the problem persists, please contact support";
export const MIN_UNIT_PRICE_ERROR_MESSAGE =
  "You cannot enter an amount lower than ₦0.01";
export const MIN_STOCK_ERROR_MESSAGE = "You cannot enter a value lower than 1";
export const MAX_UNIT_PRICE_ERROR_MESSAGE =
  "You cannot enter an amount higher than ₦9,999,999,999.99";
export const MAX_STOCK_ERROR_MESSAGE =
  "You cannot enter a value higher than 9,999,999,999";
export const MAX_2_ERROR_MESSAGE = "You cannot enter less than 2 characters.";
export const MAX_100_ERROR_MESSAGE =
  "You cannot enter more than 100 characters.";
export const FULL_PAYMENT = "FULL_PAYMENT";
export const FULL_PAYMENT_FEE = "FULL_PAYMENT_FEE";
export const LOW_STOCK_ALERT_TITLE = "Low Stock Alert";
export const LOW_STOCK_ALERT_SUBTITLE =
  "Kindly set what low stock should be for this specific product";
export const QUANTITY_COUNT = "Quantity Count";
export const CONNECTION_ERROR_MESSAGE =
  "Sorry, we are unable to process your request. Kindly check your connection and try again.";

export const OUT_OF_STOCK_MODAL_MESSAGE_EM =
  "Sorry, you can’t sell more than the available stock. Please contact your manager to restock this product.";
export const OUT_OF_STOCK_MODAL_TITLE_EM = "Out of stock";
export const ADDED_AUTHORISED_USER_SUCCESS_TITLE =
  "Authorized User Added Successfully";
export const ADDED_AUTHORISED_USER_SUCCESS_MESSAGE =
  "This user will receive an email with a link to complete the registration process.";
export const LOW_IN_STOCK_MODAL_MESSAGE =
  "The quantity you selected is more than the quantity available for this product, you can add more quantity below if you wish to proceed.";
export const OUT_OF_STOCK_MODAL_MESSAGE =
  "There is no stock available for this product, you can add stock to continue";

//Beneficiary
export const ADD_BENEFICIARY_SUCCESS_TITLE = "Beneficiary Saved Successfully";
export const ADD_BENEFICIARY_SUCCESS_MESSAGE =
  "The new beneficiary has been added successfully.";
export const ADD_BENEFICIARY_ERROR_TITLE = "Unable to Save Beneficiary";
export const ADD_BENEFICIARY_ERROR_MESSAGE =
  "We couldn't save the new beneficiary. Please try again.";
export const EDIT_BENEFICIARY_SUCCESS_TITLE =
  "Beneficiary Updated Successfully";
export const EDIT_BENEFICIARY_SUCCESS_MESSAGE =
  "Your changes to the beneficiary have been saved.";
export const EDIT_BENEFICIARY_ERROR_TITLE = "Unable to Update Beneficiary";
export const EDIT_BENEFICIARY_ERROR_MESSAGE =
  "Sorry, we couldn't save your changes. Please try again.";
export const DELETE_BENEFICIARY_SUCCESS_TITLE =
  "Beneficiary Deleted Successfully";
export const DELETE_BENEFICIARY_SUCCESS_MESSAGE =
  "The beneficiary has been removed from your list.";
export const DELETE_BENEFICIARY_ERROR_TITLE = "Unable to Delete Beneficiary";
export const DELETE_BENEFICIARY_ERROR_MESSAGE =
  "Sorry, we couldn't delete the beneficiary. Please try again.";
export const DUPLICATE_BENEFICIARY_TITLE = "Beneficiary Already Exists";
export const DUPLICATE_BENEFICIARY_MESSAGE =
  "The beneficiary is already in your list.";

//ERROR CODE TITLES
export const ERROR_CODES: Record<number | string, string> = {
  400: "An Application Error",
  401: "Authentication Error",
  403: "Authentication Error",
  404: "An Application Error",
  405: "Method Not Allowed",
  406: "Not Acceptable",
  408: "Request Timeout",
  409: "Duplicate Error",
  412: "Precondition Failed",
  415: "Unsupported Media Type",
  422: "Unprocessable Entity",

  500: "A Server Error",
  502: "Bad Gateway",
  503: "Service Unavailable",
  504: "Gateway Timeout",
  600: "A Server Error",

  connection_error: "A Connection Error",
  network_error: "A Network Error",
  unknown_error: "An Unknown Error",
  onboarding_error: "Onboarding",
};

export const UPGRADE_PER_DAY = "PER_DAY";
export const UPGRADE_PER_TRANSACTION = "PER_TRANSACTION";

export const ZENITH_NIGERIA_BANK_ID = "000015";
export const PILOT_ZENITH_NIGERIA_BANK_ID = "999191";

export const CURRENT_ZENITH_NIGERIA_BANK_ID = IS_PRODUCTION
  ? ZENITH_NIGERIA_BANK_ID
  : PILOT_ZENITH_NIGERIA_BANK_ID;

// Wallet Constants
export const WALLET = {
  ACCOUNT_PREFIX: "967",
  ACCOUNT_LENGTH: 10,
  BANK_NAME: "Finopay",
  TRANSFER_TYPE: "wallet",
} as const;

export const DEBIT_LIMIT_BREACH_TITLE = "Debit Limit Breach";
export const DEBIT_LIMIT_BREACH_MESSAGE =
  "Sorry we are unable to proceed with this transaction, kindly review the amount you intend to send";
export const DEBIT_LIMIT_VALIDATION_ERROR =
  "Amount entered is above your limit. You can only send {amount left to spend}";
export const FINOPAY_BANK_ID = "220100";

export const ACCOUNT_RESTRICTED_TITLE = "Account Restricted";
export const ACCOUNT_RESTRICTED_MESSAGE =
  "Your account is restricted from {freezeType} money. Kindly contact customer support line.";
export const ACCOUNT_RESTRICTED__TYPE = {
  DEBIT_FREEZE: "DEBIT_FREEZE",
  CREDIT_FREEZE: "CREDIT_FREEZE",
  TOTAL_FREEZE: "TOTAL_FREEZE",
  NOT_FROZEN: "NOT_FROZEN",
};
export const FINOPAY_SUPPORT_MAIL = "support@finopay.com";
export const FINOPAY_SUPPORT_TEL_NG = "+2348000003333";
